import React from 'react'

import type { DraggableProps, DraggableProvided } from 'react-beautiful-dnd'

import { Table } from '@domain-group/suit-theme'

import useOrderItemTask from '@hooks/useOrderItemTask'

import type { OrderItemModel, UserModel } from '@models/types'

interface DraggableOrderItemTaskProps {
  columns: (orderItems: OrderItemModel[], users: UserModel[]) => object[],
  dragHandleProps: DraggableProvided['dragHandleProps'],
  dragSnapshot: {
    isDragging: boolean,
  },
  draggableProps: DraggableProps,
  orderItemTaskId: number,
}

const DraggableOrderItemTask = React.forwardRef((props: DraggableOrderItemTaskProps, ref) => {
  const {
    columns,
    dragHandleProps,
    dragSnapshot,
    draggableProps,
    orderItemTaskId,
  } = props

  const { isDragging } = dragSnapshot || {}

  const { orderItemTask } = useOrderItemTask({ id: orderItemTaskId })

  return (
    <Table.DataRow
      // @ts-expect-error TS2322
      columns={columns}
      key={orderItemTask.id}
      isDragging={isDragging}
      // @ts-expect-error TS2739
      item={orderItemTask}
      ref={ref}
      {...draggableProps}
      {...dragHandleProps}
      // @ts-expect-error TS2339
      style={{ ...draggableProps.style, cursor: 'pointer' }}
    />
  )
})

export default DraggableOrderItemTask
